import { store, getElement } from '@wordpress/interactivity';

const updateURL = async ( action, value, name ) => {
	const url = new URL( action );
	if ( value || name === 's' ) {
		url.searchParams.set( name, value );
	} else {
		url.searchParams.delete( name );
	}
	const { actions } = await import( '@wordpress/interactivity-router' );
	await actions.navigate( url.toString() );
};

// Function to get the current URL parameter value
const getQueryParam = ( name ) => {
	const params = new URLSearchParams( window.location.search );
	return params.get( name );
};

const { state } = store( 'query-filter', {
	state: {
		// Initial state for the currently active term slug
		// This will be set by the PHP on initial load as well, but good practice to have a default.
		// We'll initialize it by checking the URL in the browser.
		activeTermSlug: getQueryParam( window.queryVarName ) || '',
	},
	actions: {
		// Updated navigate action for clickable list
		*navigate( e ) {
			e.preventDefault(); // Prevents page refresh

			const url = e.target.href;
			const linkUrl = new URL( url );

			// Extract the query variable name (e.g., 'category') and its value (e.g., 'slug')
			// This assumes the query var is the only one set that has a value.
			let name = null;
			let value = null;

			// Loop through search params to find the query variable being set
			// The query var is the one that is NOT page/paged and has a value
			for ( const [ key, val ] of linkUrl.searchParams.entries() ) {
				if ( key !== 'page' && key !== 'paged' ) {
					name = key;
					value = val;
				}
			}

			// Update the state with the new active term slug
			state.activeTermSlug = value || '';

			const { actions } = yield import(
				'@wordpress/interactivity-router'
			);
			yield actions.navigate( url );
		},
		*search( e ) {
			e.preventDefault();
			const { ref } = getElement();
			let action, name, value;
			if ( ref.tagName === 'FORM' ) {
				const input = ref.querySelector( 'input[type="search"]' );
				action = ref.action;
				name = input.name;
				value = input.value;
			} else {
				action = ref.closest( 'form' ).action;
				name = ref.name;
				value = ref.value;
			}

			// Don't navigate if the search didn't really change.
			if ( value === state.searchValue ) return;

			state.searchValue = value;

			yield updateURL( action, value, name );
		},
	},
	selectors: {
		// Selector to check if a term is currently active
		isActive: ( { context } ) => context.termSlug === state.activeTermSlug,
	},
} );
